var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticStyle:{"background-color":"#FFB800","color":"white","border-radius":"10px"},attrs:{"size":"sm"}},[_c('b-icon',{attrs:{"icon":"download","scale":"2","variant":"default"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }